module.exports = __webpack_public_path__ + "img/29.23070ee1.jpg";